import { Component } from '@angular/core';

import { Observable } from 'rxjs';

import { FileResponse, RendererBaseComponent } from 'sc-common';
import { FileDownloadComponent } from 'sc-external/shared/components/file-download/file-download.component';

@Component({
    templateUrl: './file-download-renderer.component.html',
    imports: [FileDownloadComponent]
})
export class FileDownloadRendererComponent extends RendererBaseComponent {

    public downloadFileExpr: (rowModel: any) => Observable<FileResponse>;

    constructor() {
        super();
    }
}
